"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _KatalMetricsDriver2 = _interopRequireDefault(require("./KatalMetricsDriver"));

var _ErrorHandler = require("./ErrorHandler");

var _KatalMetricObject = _interopRequireDefault(require("../metricObject/KatalMetricObject"));

/**
 * Logs metrics to the console.
 *
 * Mainly useful for development and experimentation.
 */
var KatalMetricsDriverConsoleLogJson =
/*#__PURE__*/
function (_KatalMetricsDriver) {
  (0, _inherits2.default)(KatalMetricsDriverConsoleLogJson, _KatalMetricsDriver);

  /**
   * Create a new console metrics logger.
   *
   * @param logConsole Console (or console-like object) to log metrics to
   * @param errorHandler Callback in case of error
   */
  function KatalMetricsDriverConsoleLogJson() {
    var _this;

    var logConsole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : console;
    var errorHandler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _ErrorHandler.DEFAULT_ERROR_HANDLER;
    (0, _classCallCheck2.default)(this, KatalMetricsDriverConsoleLogJson);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(KatalMetricsDriverConsoleLogJson).call(this));
    _this._errorHandler = errorHandler;
    _this._console = logConsole;
    return _this;
  }

  (0, _createClass2.default)(KatalMetricsDriverConsoleLogJson, [{
    key: "publish",
    // TODO: errorHandler in this method is deprecated and will be removed.
    value: function publish(metricObject, errorHandler, context) {
      var fields = (0, _objectSpread2.default)({}, context.getFields());

      switch (metricObject.type) {
        case _KatalMetricObject.default.Types.String:
        case _KatalMetricObject.default.Types.Counter:
        case _KatalMetricObject.default.Types.Timer:
          (0, _extends2.default)(fields, {
            type: metricObject.type,
            metricKey: metricObject.name,
            value: metricObject.value
          });

          if (metricObject.isMonitor) {
            fields.isMonitor = true;
          }

          break;

        default:
          var err = new Error("Unknown type ".concat(metricObject.type, " when publishing metric object."));
          this.errorHandler(err);
          return;
      }

      this._console.log(fields);
    }
  }, {
    key: "errorHandler",
    get: function get() {
      return this._errorHandler;
    }
  }]);
  return KatalMetricsDriverConsoleLogJson;
}(_KatalMetricsDriver2.default);

exports.default = KatalMetricsDriverConsoleLogJson;